// Ensure current search will be the first lastSearch and also considering duplicate prevention as well as the limit of items in the list
export const generateLastSearchesWithoutDuplicates = (lastSearches, current, limit) => [current, ...lastSearches.filter(({ link }) => link !== current.link).slice(0, limit - 1)];
